import get from 'lodash-es/get';

export default namespaceSettings =>
  get(namespaceSettings, 'config.visibilityArchivalState', '');



// WEBPACK FOOTER //
// ./client/routes/namespace/workflow-archival/helpers/get-visibility-archival-state.js